
import { DocumentDuplicateIcon, CloudUploadIcon} from "@heroicons/react/outline";
import { ReactComponent as BucketIcon } from '../assets/icons/bucket.svg';
import {buckets_} from "../App";
import {useRecoilState} from "recoil";
import {useEffect, useState} from "react";
import {humanFileSize} from "../utils/v56l_file";

export default function StatsDisplay() {

    const [buckets, setBuckets] = useRecoilState(buckets_);
    const [totalSize, setTotalSize] = useState(0);
    const [totalFiles, setTotalFiles] = useState(0);

    useEffect(() => {
        var totalFiles = 0.0;
        var totalSize = 0.0;
        for (let bucket of buckets){
            totalFiles += Number(bucket.number_of_files);
            totalSize += Number(bucket.bucket_size);
        }
        setTotalFiles(totalFiles);
        setTotalSize(totalSize);
    }, [buckets]);

    const stats = [
        { name: 'Buckets', stat: buckets.length, icon: BucketIcon },
        { name: 'Stored Data', stat: humanFileSize(totalSize), icon: CloudUploadIcon },
        { name: 'Files', stat: totalFiles, icon: DocumentDuplicateIcon },
    ]

    return (
        <div>
            <dl className="grid sm:grid-cols-3 grid-cols-3 gap-5 pt-2">
                {stats.map((item) => (
                    <div key={item.name} className="px-4 bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="grid grid-cols-2">
                            <span>
                                <dt className="text-sm font-small text-gray-500 truncate">{item.name}</dt>
                                <dd className="mt-1 text-1xl font-semibold text-gray-900">{item.stat}</dd>
                            </span>
                            <span className="flex justify-end items-center invisible sm:visible">
                                <item.icon className="h-6 w-6"/>
                            </span>
                        </div>
                    </div>
                ))}
            </dl>
        </div>
    )
}
